<template>
  <div class="sidebar-item flex-1" v-bind:class="{ 'disabled': isActive === false}">
    <div class="d-flex justify-content-between">
      <div class="font-weight-bold text-white">{{ 'Prompt' | trans }}</div>
      <div class="text-muted font-weight-bold"></div>
    </div>
    <prompt></prompt>
  </div>
</template>
<script>
import store from './../../../mixins/store.mixin'
import currentJob from './../../../mixins/current_job.mixin'
import UploadBox from "../../Elements/UploadBox.vue";
import CanvasManager from "../../../manager/CanvasManager";
import Prompt from "../../Elements/Prompt.vue";

export default {
  name: "PromptElement",
  props: {},
  components: {Prompt, UploadBox},
  mixins: [
    store,
    currentJob
  ],
  data() {
    return {
      item_open: false
    };
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    next() {
      if (this.isDone === false) {
        return;
      }
      this.activeStage.activeStep = 'settings';
    },
    activate() {
      if (this.isActive === false) {
        return;
      }
      this.activeStage.activeStep = 'prompt';
    }
  },
  computed: {
    isActive() {
      return this.currentJob.state !== 'processing';
    },
    isDone() {
      return this.activeStage.settings.prompt !== '';
    }
  }
};
</script>
<style lang="scss" scoped>
.next-btn {
  cursor: pointer;

  color: white;
  border-radius: 4px;
  background: #1266F1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 0 20px;
  gap: 20px;
  font-size: 17.5px;

  border: none;

  &.disabled {
    cursor: not-allowed;
  }
}


.gap-10px {
  gap: 10px;
}

.gap-20px {
  gap: 20px;
}

.gap-30px {
  gap: 30px;
}

.gap-40px {
  gap: 40px;
}
</style>
